import { render, staticRenderFns } from "./CarouselItemMobile.vue?vue&type=template&id=e783fd54&scoped=true&"
import script from "./CarouselItemMobile.vue?vue&type=script&lang=js&"
export * from "./CarouselItemMobile.vue?vue&type=script&lang=js&"
import style0 from "./CarouselItemMobile.vue?vue&type=style&index=0&id=e783fd54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e783fd54",
  null
  
)

export default component.exports